import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import styled from "styled-components";

export const LimitBanner = styled.div`
    width: calc(100% - 35px);
    display: flex;
    height: 48px;
    padding: 4px 12px 4px 16px;
    background: ${colorsPalettes.bluegrey["200"]};
    box-sizing: border-box;
    margin: 0 10px;
    align-items: center;
`;

export const LimitText = styled.p`
    ${setFontVariant("body1")}
    color: ${colorsPalettes.carbon["400"]};
    margin: 0 0 0 8px;
`;
